import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref, watch } from 'vue';
import { MFAActionType, MFAState, MFAType, UserStatus } from 'ah-api-gateways';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { maskedEmail } from 'ah-common-lib/src/helpers/email';
import config from '@/config';
import { BModal } from 'bootstrap-vue';
import { useAuthStore } from '@/app/store/authStore';
import MFAForm from '@/app/components/session/MFAForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountVerificationForm',
  emits: ["proceed", "back", "login-error"],
  setup(__props, { emit }: { emit: ({ (e: 'proceed'): void; (e: 'back'): void; (e: 'login-error', error: any): void }), expose: any, slots: any, attrs: any }) {

const requestManagerParent = useRequestManager();
const requestManager = requestManagerParent.manager;

const authStore = useAuthStore();

const phoneOTP = ref<InstanceType<typeof MFAForm> | null>(null);
const emailOTP = ref<InstanceType<typeof MFAForm> | null>(null);
const expireModal = ref<InstanceType<typeof BModal> | null>(null);

const state = reactive<{
  phoneOtp: string;
  emailOtp: string;
  phoneStatus: MFAState;
  emailStatus: MFAState;
}>({
  phoneOtp: '',
  emailOtp: '',
  phoneStatus: MFAState.NOT_REQUESTED,
  emailStatus: MFAState.NOT_REQUESTED,
});



const staticOTP = computed(() => config.staticOTP);

const otpPhone = computed(
  () => authStore.loggedInUser?.phoneNumber.substring(authStore.loggedInUser!.phoneNumber.length - 4) || ''
);

const otpEmail = computed(() => (authStore.loggedInUser ? maskedEmail(authStore.loggedInUser.email) : '-'));

const phoneMFA = computed(() => ({ actionType: MFAActionType.REGISTRATION, type: MFAType.SMS_OTP }));

const emailMFA = computed(() => ({ actionType: MFAActionType.REGISTRATION, type: MFAType.EMAIL_OTP }));

const anyPending = computed(
  () =>
    requestManager.anyPending ||
    requestManagerParent.getAllRequestsInState('pending').filter((r) => r.request.startsWith('submitMFA')).length > 0
);

const allSubmitted = computed(() => state.phoneStatus === MFAState.SUCCESS && state.emailStatus === MFAState.SUCCESS);

function refreshCodes() {
  if (state.phoneStatus === MFAState.EXPIRED) {
    phoneOTP.value?.refreshMFA();
  }
  if (state.emailStatus === MFAState.EXPIRED) {
    emailOTP.value?.refreshMFA();
  }
}

function submitRegistration() {
  requestManager.newPromise('redeemTokens', authStore.registrationMfa()).then(
    () => emit('proceed'),
    (e) => emit('login-error', e)
  );
}

function back() {
  emit('back');
}

watch(
  () => [state.phoneStatus, state.emailStatus],
  () => {
    if (state.phoneStatus === MFAState.EXPIRED && state.emailStatus === MFAState.EXPIRED) {
      expireModal.value?.show();
    } else if (state.phoneStatus === MFAState.SUCCESS && state.emailStatus === MFAState.SUCCESS) {
      submitRegistration();
    } else {
      expireModal.value?.hide();
    }
  }
);

if (authStore.loggedInUser?.status === UserStatus.VERIFIED) {
  emit('proceed');
}

return { __sfc: true,requestManagerParent, requestManager, authStore, phoneOTP, emailOTP, expireModal, state, emit, staticOTP, otpPhone, otpEmail, phoneMFA, emailMFA, anyPending, allSubmitted, refreshCodes, submitRegistration, back, UserStatus, BModal, MFAForm }
}

})